import { useEffect } from 'react';

function useOutsideClick(isActive, callback) {
    useEffect(() => {
        if (!isActive) return;
        window.addEventListener('click', callback);
        return () => window.removeEventListener('click', callback);
    }, [isActive, callback]);
}

export default useOutsideClick;
